// extracted by mini-css-extract-plugin
export default {"forgotPassword":"forgot-password_forgotPassword__Y6naO","container":"forgot-password_container__TGijS","form":"forgot-password_form__y+JQg","rotate":"forgot-password_rotate__6z97V"};